import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children, wrapperId = 'color-picker-portal-wrapper', className }) => {
  const [wrapperElement, setWrapperElement] = useState(null);

  useEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;

    if (!element) {
      systemCreated = true;
      element = document.createElement('div');
      element.setAttribute('id', wrapperId);
      element.style.zIndex = '9999';
      element.style.position = 'absolute'; 
      element.style.top = '0';
      element.style.left = '0';
      document.body.appendChild(element);
    }

    if (className) {
      element.className = className; 
    } else {
      element.className = ''; 
    }

    setWrapperElement(element);

    return () => {
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId, className]);

  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};

export default Portal;